export enum Gender {
  none = "None",
  boy = "Male",
  girl = "Female",
}

export enum FollowupStatus {
  active = "Active",
  completed = "Completed",
  draft = "Draft",
  planned = "Submitted",
}
